export const Service = ()=>{
    return(
        <>
             <div id="ministere" className="our-services section">
    <div className="container">
      <div className="row">
      <div className="col-lg-6 wow fadeInRight" data-wow-duration="1s" data-wow-delay="0.2s">
          <div className="section-heading">
            <h2>Le <em>Ministère</em></h2>
            <h4 style={{fontWeight:"normal"}} className="mt-3">Notre plateforme vise à moderniser et à simplifier les paiements fiscaux au Congo Brazzaville. En utilisant notre service en ligne, vous évitez les files d'attente et gagnez du temps tout en respectant vos obligations fiscales.</h4>
          </div>
          
         
        </div>

        <div className="col-lg-6 align-self-center  wow fadeInLeft monTop" data-wow-duration="1s" data-wow-delay="0.2s">
          <div className="left-image monLeft ">
            <img src="assets/images/logo_fr_1.png" style={{width: "28em"}}  alt="" />
          </div>
        </div>
       
      </div>
     
    </div>
  </div>
        </>
    )
}